/** Superboard (application-level administration) payload schemas. */

import { z } from "zod";
import { APP_ROLES } from "../constants/roles";
import { pageQuerySchema } from "./common";

export const updateAppRoleSchema = z.object({
  app_role: z.enum([APP_ROLES.superuser, APP_ROLES.user]),
});

export const upsertAppSettingSchema = z.object({
  key: z.string().trim().min(1).max(64),
  value: z.record(z.string().max(64), z.unknown()),
});

export const adminListQuerySchema = pageQuerySchema.extend({
  q: z.string().trim().max(120).optional(),
});

export const publicInvoiceTokenSchema = z.object({
  publicToken: z.string().trim().min(8).max(64),
});
